import classes from '../../../framework/framework/tools/classes';
import { IProductImage } from '../dataModels/ProductModels';
import * as style from './style.css';
import React = require('react');

interface IProps {
    images: IProductImage[];
}
interface IState {
    current: IProductImage;

}

export default class ImageShow extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);
        this.state = {
            current: this.props.images[0]
        };
    }

    render() {
        return (
            <div className={style.imageShow}>
                <div className={style.image}>
                    {this.state.current &&
                        <img src={this.state.current.thumbnail + '/500'}></img>
                    }
                </div>
                <div className={style.thumbnails}>
                    {this.props.images.map(x => this.imageThumbnail(x))}
                </div>
            </div>
        );
    }

    imageThumbnail(x: IProductImage): any {
        const activeStyle = this.state.current.id === x.id ? style.activeThumbnail : '';
        return <div key={x.id} className={classes(style.thumbnail, activeStyle)} onClick={() => this.onThumbnailClick(x)}>
            <img src={x.thumbnail + '/100'}></img>
        </div>;
    }

    onThumbnailClick(x: IProductImage): void {
        this.setState({ current: x });
    }
}
